export type RichText = string

export const stripStyling = (text: RichText): string => {
  // Parse html
  const html = document.createElement("div")
  html.innerHTML = text

  // Get all elements
  var elements = html.getElementsByTagName("*");

  // For each element
  for (var i = 0; i < elements.length; i++) {
    // remove the style attribute
    if (elements[i].hasAttribute('style')) {
      elements[i].removeAttribute('style');
    }
  }
  
  return html.innerHTML
}